import { startOfMonth, lastDayOfMonth, subMonths } from 'date-fns';

export const getFirstDayOfPreviousMonth = () => {
    return startOfMonth(subMonths(new Date(), 1));
}

export const getLastDayOfPreviousMonth = () => {
    return lastDayOfMonth(subMonths(new Date(), 1));
}